import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

interface ApiEnvelope {
  message: string;
  status: number;
  data: unknown;
}

export const responseInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body;
        if (
          event.status >= 200 &&
          event.status < 300 &&
          body !== null &&
          typeof body === 'object' &&
          !Array.isArray(body) &&
          'data' in body &&
          'message' in body &&
          'status' in body
        ) {
          return event.clone({ body: (body as ApiEnvelope).data });
        }
      }
      return event;
    }),
  );
